import { CHART_CONSTANTS } from '../constants';
import { ChartData, ChartDataPoint, ChartSeries, CriticalIssuesData } from '../types';

export const prepareDataForCriticalIssuesChart = (data: CriticalIssuesData[]): ChartData => {
	if (!data || data.length === 0) {
		return { categories: [], series: [] };
	}

	// Sort data by date to ensure proper chronological order
	const sortedData = [...data].sort(
		(a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
	);

	const categories = sortedData.map((item) => {
		const date = new Date(item.date);
		return date.toLocaleDateString('en-US', {
			month: 'short',
			day: '2-digit',
			year: 'numeric'
		});
	});

	// Create data points for total count (critical + serious)
	const chartDataPoints: ChartDataPoint[] = sortedData.map((item, index) => {
		const date = new Date(item.date);
		const formattedDate = date.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'long',
			day: '2-digit'
		});
		const tooltipDate = date.toLocaleDateString('en-US', {
			month: 'short',
			day: '2-digit',
			year: 'numeric'
		});
		const formatter = new Intl.NumberFormat('en-US');

		return {
			x: index,
			y: item.total,
			name: `Total Issues: ${item.total} (Critical: ${item.critical}, Serious: ${item.serious}) - ${formattedDate}`,
			date: tooltipDate, // Use formatted date for tooltip
			count: formatter.format(item.total),
			critical: formatter.format(item.critical),
			serious: formatter.format(item.serious),
			total: formatter.format(item.total),
			// Use raw numeric values for sorting (table will sort these numerically)
			criticalSortValue: item.critical,
			seriousSortValue: item.serious,
			totalSortValue: item.total,
			id: `critical-issues-${item.date}-${item.total}` // Add unique ID for table rows
		};
	});

	const series: ChartSeries[] = [
		{
			type: 'line',
			name: CHART_CONSTANTS.SERIES.NAME,
			data: chartDataPoints,
			color: CHART_CONSTANTS.COLORS.PRIMARY_LINE,
			lineWidth: CHART_CONSTANTS.LINE.WIDTH,
			marker: {
				enabled: true,
				fillColor: CHART_CONSTANTS.COLORS.PRIMARY_LINE,
				lineColor: CHART_CONSTANTS.COLORS.PRIMARY_LINE,
				lineWidth: 2,
				radius: CHART_CONSTANTS.LINE.MARKER_RADIUS
			}
		}
	];

	return {
		categories,
		series
	};
};
